/** Mirrors PsycheFlow-Mobile2/assets/terms-of-service.html — keep in sync. No app-autostart clauses. */
export const TERMS_OF_SERVICE_LAST_UPDATED = '2026年7月29日';

export function TermsOfServiceDocument() {
  return (
    <article className="text-[15px] leading-7 text-[#2D3139]">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-extrabold tracking-tight text-ink">用户协议</h1>
        <p className="text-sm text-muted">颗粒日记 · 最后更新：{TERMS_OF_SERVICE_LAST_UPDATED}</p>
        <p className="mt-1 text-sm text-muted">开发者名称：北京颗粒日记科技有限公司</p>
      </header>

      <div className="mb-6 rounded-md border-l-[3px] border-primary bg-[#EAF2FF] px-3.5 py-3 text-sm text-[#2D3139]">
        欢迎使用颗粒日记。请您在注册或使用本应用前认真阅读并同意本用户协议。使用本应用即表示您已阅读并同意接受本协议全部内容。
      </div>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">一、协议适用范围</h2>
        <p>
          本协议是您与北京颗粒日记科技有限公司（以下简称「我们」）之间关于使用颗粒日记（以下简称「本应用」）相关服务所订立的协议。本协议与
          <a href="/privacy" className="font-semibold text-primary hover:underline">《隐私政策》</a>
          共同构成您使用本服务的完整约定。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">二、账户与使用规范</h2>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>您应使用真实、有效的手机号码完成注册与身份验证，并妥善保管账户信息。</li>
          <li>您不得利用本应用从事违法违规活动，不得上传、发布违法、侵权或不当内容。</li>
          <li>您对自己上传或创建的学习素材、笔记等内容负责，并保证对其拥有合法权利。</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">三、服务说明</h2>
        <p className="mb-3">
          本应用按「现状」提供学习素材管理、知识颗粒与复习等功能。我们会尽力保障服务可用性，但不对服务不中断或不存在瑕疵作出保证。
        </p>
        <p>本应用中的 AI 生成内容仅供学习参考，不构成专业教育、医疗或法律建议。</p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">四、知识产权</h2>
        <p>
          本应用的软件、界面、标识及相关内容的知识产权归我们或权利人所有。未经许可，您不得复制、修改、传播或以其他方式使用前述内容（法律法规另有规定的除外）。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">五、账户注销</h2>
        <p>
          您可在应用内按指引申请注销账户。注销后，我们将按《隐私政策》及相关法律法规处理您的个人信息。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">六、协议变更与联系方式</h2>
        <p className="mb-3">
          我们可能适时修订本协议。重大变更时，将在应用内显著位置提示。继续使用本应用即视为您接受更新后的协议。
        </p>
        <p>
          如有疑问，请通过应用内「关于」页面的联系方式，或发送邮件至
          <strong className="font-semibold text-ink"> keliriji@163.com </strong>
          与我们联系。
        </p>
      </section>

      <hr className="my-8 border-border" />
      <p className="text-center text-sm text-[#8A9CB8]">© 2026 北京颗粒日记科技有限公司 · 版权所有</p>
    </article>
  );
}
